// This file is auto-generated by @hey-api/openapi-ts

export type AccessToken = {
    id?: string;
    email: string;
    verified?: boolean;
    authSource?: ('auth0' | 'regen_api' | null);
    credentials?: string;
    [key: string]: unknown | string | boolean;
};

/**
 * Pydantic model used to represent the essential fields of an account, with
 * the addition of the account's ID.
 */
export type AccountGet = {
    fullName: string;
    displayName: string;
    id: string;
    [key: string]: unknown | string;
};

/**
 * A schema to support editing account roles. Only used internally.
 */
export type AccountInternalUpdate = {
    fullName: string;
    displayName: string;
    roles: Array<('admin' | 'staff' | 'grower')>;
    [key: string]: unknown | string;
};

/**
 * Pydantic model used to represent the essential fields needed to update
 * an existing account.
 */
export type AccountUpdate = {
    fullName: string;
    displayName: string;
    [key: string]: unknown | string;
};

export type AnnumsList = {
    annums: Array<(number)>;
    /**
     * A Vayda growing year, starting with harvest (Oct 1) of the previous calendar year
     */
    latest: number;
    [key: string]: unknown | number;
};

export type AttachmentResponse = {
    key: string;
    datasource: 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';
    farm_id: string;
    created_at: string;
};

export type datasource = 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';

export const datasource = {
    ELEVATION: 'elevation',
    FIELD_BOUNDARY: 'field_boundary',
    HANEY_LAB: 'haney_lab',
    MISC_LAB: 'misc_lab',
    OTHERS: 'others',
    PHOTO: 'photo',
    PLFA_LAB: 'plfa_lab',
    SAMPLING_PLAN: 'sampling_plan',
    SAMPLING_POINTS: 'sampling_points',
    SOIL_LAB: 'soil_lab',
    TEXTURE_LAB: 'texture_lab',
    TND_LAB: 'tnd_lab',
    VERIS_LAB: 'veris_lab',
    PKS_LIME_RX: 'pks_lime_rx',
    DEEP_TILLAGE_PLAN: 'deep_tillage_plan'
} as const;

export type BaseModel = {
    [key: string]: unknown;
};

export type Body_create_cms_attachment_farms__farm_id__annum__annum__attachments_cms_post = {
    file: (Blob | File);
};

export type ChangePasswordTicket = {
    email: string;
    url: string;
    [key: string]: unknown | string;
};

/**
 * Represents a web-safe RGB color.
 *
 * Serializes to a hex color string.
 */
export type Color = string;

/**
 * A bundle of colorized imagery layers.
 */
export type ColorizedBundleResponse = {
    acquiredAt: string;
    productType: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    anomaliesUrl: string;
    deltaFromNormUrl: string;
    varianceMapUrl: string;
    normMapUrl: string;
    productUrl: string;
    unusableMaskUrl: string;
    [key: string]: unknown | string;
};

export type productType = 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';

export const productType = {
    NDVI: 'ndvi',
    ENDVI: 'endvi',
    EVI: 'evi',
    MSAVI: 'msavi',
    CCCI: 'ccci',
    NDRE: 'ndre'
} as const;

/**
 * A bundle of data representing a colorized imagery layer.
 */
export type ColorizedLayerResponse = {
    acquiredAt: (string | null);
    layer: 'anomalies' | 'delta-from-norm' | 'norm-map' | 'variance-map' | 'unusable-mask' | 'product';
    url: string;
    legend: Legend;
    [key: string]: unknown | string | Legend;
};

export type layer = 'anomalies' | 'delta-from-norm' | 'norm-map' | 'variance-map' | 'unusable-mask' | 'product';

export const layer = {
    ANOMALIES: 'anomalies',
    DELTA_FROM_NORM: 'delta-from-norm',
    NORM_MAP: 'norm-map',
    VARIANCE_MAP: 'variance-map',
    UNUSABLE_MASK: 'unusable-mask',
    PRODUCT: 'product'
} as const;

export type DatasourceModel = {
    datasource: 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';
    description: string;
    group: 'FIELD_BOUNDARIES' | 'LAB_REPORTS' | 'MISCELLANEOUS' | 'PHOTOS' | 'SAMPLE_POINTS' | 'PRESCRIPTIONS' | 'OTHER';
    extensions: Array<('.gpkg' | '.zip' | '.jpg' | '.png' | '.csv' | '.xml' | '*')>;
};

export type group = 'FIELD_BOUNDARIES' | 'LAB_REPORTS' | 'MISCELLANEOUS' | 'PHOTOS' | 'SAMPLE_POINTS' | 'PRESCRIPTIONS' | 'OTHER';

export const group = {
    FIELD_BOUNDARIES: 'FIELD_BOUNDARIES',
    LAB_REPORTS: 'LAB_REPORTS',
    MISCELLANEOUS: 'MISCELLANEOUS',
    PHOTOS: 'PHOTOS',
    SAMPLE_POINTS: 'SAMPLE_POINTS',
    PRESCRIPTIONS: 'PRESCRIPTIONS',
    OTHER: 'OTHER'
} as const;

export type Datasources = {
    datasources?: Array<DatasourceModel>;
};

/**
 * A listing of all the dates available for a layer.
 */
export type DatesForLayer = {
    dates: Array<(string)>;
    [key: string]: unknown | string;
};

/**
 * Serialize information about the account for the role
 */
export type FarmAccountGet = {
    role: 'owner' | 'operator' | 'customer_rep';
    account: AccountGet;
    [key: string]: unknown | string | AccountGet;
};

export type role = 'owner' | 'operator' | 'customer_rep';

export const role = {
    OWNER: 'owner',
    OPERATOR: 'operator',
    CUSTOMER_REP: 'customer_rep'
} as const;

/**
 * Roles for a given account id
 */
export type FarmAccountRole = {
    accountId: string;
    roles: Array<('owner' | 'operator' | 'customer_rep')>;
    [key: string]: unknown | string;
};

/**
 * A schema to support editing the list of users with farm roles.
 */
export type FarmAccountRoleEdit = {
    users: Array<FarmAccountRole>;
    [key: string]: unknown | FarmAccountRole;
};

export type FarmAnnums = {
    label: string;
    acreage: (number | null);
    yearsOperated: (number | null);
    yieldIssues: (string | null);
    zipcode: (string | null);
    goals: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    id: string;
    annums: Array<(number)>;
    /**
     * A Vayda growing year, starting with harvest (Oct 1) of the previous calendar year
     */
    latestAnnum: number;
    [key: string]: unknown | string | number;
};

/**
 * A schema for the data required to create a farm.
 */
export type FarmCreate = {
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    [key: string]: unknown | string;
};

/**
 * A schema for the data required to edit a farm.
 */
export type FarmEdit = {
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    [key: string]: unknown | string;
};

export type FarmGet = {
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    id: string;
    roles?: Array<('owner' | 'operator' | 'customer_rep')>;
    permissions?: Array<('account:change_password' | 'account:create' | 'account:delete' | 'account:list' | 'account:read' | 'account:update' | 'account_internal:read' | 'account_internal:update' | 'farm:create' | 'farm:delete' | 'farm:invite' | 'farm:list' | 'farm:publicize' | 'farm:read' | 'farm:update' | 'farm:upload' | 'farm_internal:create' | 'farm_internal:list' | 'farm_internal:read' | 'farm_internal:update' | 'system_content:read' | 'system_content:update')>;
    registeredAcres?: number;
    enrolledAcres?: number;
    customerRep?: (AccountGet | null);
    users?: Array<FarmAccountGet>;
    isPublic?: boolean;
    [key: string]: unknown | string | number | FarmAccountGet | boolean;
};

/**
 * Invite a specific user (by email) to a farm as either an owner or operator.
 *
 * Right now this schema is ONLY used by admins/staff due to invite flow
 * limitations.
 */
export type FarmInvite = {
    email: string;
    role: 'owner' | 'operator';
    [key: string]: unknown | string;
};

export type role2 = 'owner' | 'operator';

export const role2 = {
    OWNER: 'owner',
    OPERATOR: 'operator'
} as const;

export type FarmInviteResponse = {
    farmId: string;
    accountId: string;
    roles: Array<('owner' | 'operator' | 'customer_rep')>;
    isNewAccount?: boolean;
    changePasswordTicket?: (ChangePasswordTicket | null);
    [key: string]: unknown | string | boolean;
};

export type FarmSummary = {
    id: string;
    label: string;
    [key: string]: unknown | string;
};

export type FarmWithInternalCreate = {
    internalId?: (string | null);
    name?: (string | null);
    agreementStartsOn?: (string | null);
    agreementEndsOn?: (string | null);
    projectUrl?: (string | null);
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    [key: string]: unknown | string;
};

export type FarmWithInternalEdit = {
    internalId?: (string | null);
    name?: (string | null);
    agreementStartsOn?: (string | null);
    agreementEndsOn?: (string | null);
    projectUrl?: (string | null);
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    [key: string]: unknown | string;
};

export type FarmWithInternalGet = {
    internalId?: (string | null);
    name?: (string | null);
    agreementStartsOn?: (string | null);
    agreementEndsOn?: (string | null);
    projectUrl?: (string | null);
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    id: string;
    roles?: Array<('owner' | 'operator' | 'customer_rep')>;
    permissions?: Array<('account:change_password' | 'account:create' | 'account:delete' | 'account:list' | 'account:read' | 'account:update' | 'account_internal:read' | 'account_internal:update' | 'farm:create' | 'farm:delete' | 'farm:invite' | 'farm:list' | 'farm:publicize' | 'farm:read' | 'farm:update' | 'farm:upload' | 'farm_internal:create' | 'farm_internal:list' | 'farm_internal:read' | 'farm_internal:update' | 'system_content:read' | 'system_content:update')>;
    registeredAcres?: number;
    enrolledAcres?: number;
    customerRep?: (AccountGet | null);
    users?: Array<FarmAccountGet>;
    isPublic?: boolean;
    hasFields: boolean;
    hasSoilLab?: (boolean | null);
    centroid?: (Point | null);
    [key: string]: unknown | string | number | FarmAccountGet | boolean;
};

/**
 * Feature Model
 */
export type Feature = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'Feature';
    geometry: ((Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon | GeometryCollection) | null);
    properties: ({
    [key: string]: unknown;
} | BaseModel | null);
    id?: (number | string | null);
};

export type type = 'Feature';

export const type = {
    FEATURE: 'Feature'
} as const;

/**
 * FeatureCollection Model
 */
export type FeatureCollection = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'FeatureCollection';
    features: Array<Feature>;
};

export type type2 = 'FeatureCollection';

export const type2 = {
    FEATURE_COLLECTION: 'FeatureCollection'
} as const;

/**
 * Fields are areas of the farm that are managed in the same way throughout a
 * season.
 */
export type Field = {
    name: string;
    irrigation?: 'none' | 'furrow' | 'pivot' | 'flood';
    id?: string;
    farmId?: string;
    createdAt?: string;
    updatedAt?: string;
    /**
     * Returns the most recent boundary for this field.
     */
    readonly boundary: (FieldBoundary);
    [key: string]: unknown | string;
};

export type irrigation = 'none' | 'furrow' | 'pivot' | 'flood';

export const irrigation = {
    NONE: 'none',
    FURROW: 'furrow',
    PIVOT: 'pivot',
    FLOOD: 'flood'
} as const;

export type FieldBoundary = {
    id?: string;
    fieldId?: string;
    geometry: MultiPolygon;
    createdAt?: string;
    /**
     * The total area of the field in acres.
     */
    readonly acres: number;
};

export type FieldBoundaryGet = {
    geometry: MultiPolygon;
    id: string;
    acres: number;
    [key: string]: unknown | MultiPolygon | string | number;
};

export type FieldCreate = {
    name: string;
    irrigation?: 'none' | 'furrow' | 'pivot' | 'flood';
    geometry: MultiPolygon;
    cashCrop?: ('corn' | 'soybeans' | 'rice' | 'cotton' | 'fallow' | 'other' | 'melons' | 'sweet_potatoes' | null);
    [key: string]: unknown | string | MultiPolygon;
};

export type FieldEdit = {
    name: string;
    irrigation?: 'none' | 'furrow' | 'pivot' | 'flood';
    geometry?: (MultiPolygon | null);
    cashCrop?: ('corn' | 'soybeans' | 'rice' | 'cotton' | 'fallow' | 'other' | 'melons' | 'sweet_potatoes' | null);
    [key: string]: unknown | string;
};

export type FieldWithCurrentBoundary = {
    name: string;
    irrigation?: 'none' | 'furrow' | 'pivot' | 'flood';
    id: string;
    farmId: string;
    currentBoundary: FieldBoundaryGet;
    cashCrop?: ('corn' | 'soybeans' | 'rice' | 'cotton' | 'fallow' | 'other' | 'melons' | 'sweet_potatoes' | null);
    enrolled: boolean;
    [key: string]: unknown | string | FieldBoundaryGet | boolean;
};

export type FieldWithInternalEdit = {
    name: string;
    irrigation?: 'none' | 'furrow' | 'pivot' | 'flood';
    geometry?: (MultiPolygon | null);
    cashCrop?: ('corn' | 'soybeans' | 'rice' | 'cotton' | 'fallow' | 'other' | 'melons' | 'sweet_potatoes' | null);
    enrolled: boolean;
    [key: string]: unknown | string | boolean;
};

/**
 * GeometryCollection Model
 */
export type GeometryCollection = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'GeometryCollection';
    geometries: Array<(Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon | GeometryCollection)>;
};

export type type3 = 'GeometryCollection';

export const type3 = {
    GEOMETRY_COLLECTION: 'GeometryCollection'
} as const;

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

/**
 * A bundle of URLs associated with an imagery deliverable.
 */
export type ImageryDelivery = {
    acquiredAt: string;
    url: string;
    [key: string]: unknown | string;
};

/**
 * The status of an imagery deliverable.
 */
export type ImageryFieldStatus = {
    status: 'untracked' | 'preparing' | 'active' | 'completed' | 'stalled';
    listUnusableMasksUrl: string;
    listProductsUrls: {
        [key: string]: (string);
    };
    listColorizedBundlesUrls: {
        [key: string]: {
            [key: string]: (string);
        };
    };
    [key: string]: unknown | string;
};

export type status = 'untracked' | 'preparing' | 'active' | 'completed' | 'stalled';

export const status = {
    UNTRACKED: 'untracked',
    PREPARING: 'preparing',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    STALLED: 'stalled'
} as const;

/**
 * A sequence of legend ranges based on a provided layer raster file.
 */
export type Legend = {
    ranges: Array<LegendRange>;
    [key: string]: unknown | LegendRange;
};

/**
 * A legend spec bin applied to an actual raster file.
 */
export type LegendRange = {
    label: string;
    color: Color;
    percent: number;
    maximum: number;
    minimum: number;
    [key: string]: unknown | string | Color | number;
};

/**
 * LineString Model
 */
export type LineString = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'LineString';
    coordinates: Array<(Position2D | Position3D)>;
};

export type type4 = 'LineString';

export const type4 = {
    LINE_STRING: 'LineString'
} as const;

export type ModuleSectionEdit = {
    content?: TiptapContent;
};

export type ModuleSectionGet = {
    content?: TiptapContent;
    cmsId: string;
    authorId: string;
    moduleType?: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    sectionType?: 'background' | 'nutrient_maps' | 'total_fertilizer' | 'fertilizer_map' | 'prescription_files' | 'recommended_mixes' | 'farm_wide_planting' | 'cover_crop_farm_mixes' | 'cover_crop_mix' | 'cover_crop_species' | 'cover_crop_mixes' | 'termination_plan' | 'cover_crop_roi' | 'cover_crop_composition' | 'biomass_cc_variability' | 'carbon_cc_variability' | 'nitrogen_cc_variability' | 'cn_ratio_cc_variability' | 'phosphorus_cc_variability' | 'potassium_cc_variability' | 'calcium_cc_variability' | 'magnesium_cc_variability' | 'sulfur_cc_variability' | 'zinc_cc_variability' | 'iron_cc_variability' | 'manganese_cc_variability' | 'copper_cc_variability' | 'boron_cc_variability' | 'advisor_farm_notes' | 'advisor_field_notes' | 'planting_dates' | 'planting_method' | 'termination_method' | 'benefits_analysis' | 'soil_compaction' | 'compaction_summary_farm' | 'compaction_summary_field' | 'compaction_map_farm' | 'depth_to_compaction_map' | 'average_resistance_chart' | 'soil_resistance_2_inch' | 'soil_resistance_4_inch' | 'soil_resistance_6_inch' | 'soil_resistance_8_inch' | 'soil_resistance_10_inch' | 'soil_resistance_12_inch' | 'soil_resistance_14_inch' | 'subsoil_map' | 'tillage_plan' | 'tillage_map' | 'recommendations' | 'overview' | 'lime_prescription' | 'lime_prescription_map' | 'phosphorus_prescription' | 'phosphorus_prescription_map' | 'potassium_prescription' | 'potassium_prescription_map' | 'sulfur_prescription' | 'sulfur_prescription_map' | 'problem_fields' | 'nutrient_test_results' | 'calcium_compare_fields' | 'calcium_compare_fields_map' | 'phosphate_compare_fields' | 'phosphate_compare_fields_map' | 'sulfur_compare_fields' | 'sulfur_compare_fields_map' | 'potassium_compare_fields' | 'potassium_compare_fields_map' | 'magnesium_compare_fields' | 'magnesium_compare_fields_map' | 'sodium_compare_fields' | 'sodium_compare_fields_map' | 'zinc_compare_fields' | 'zinc_compare_fields_map' | 'manganese_compare_fields' | 'manganese_compare_fields_map' | 'iron_compare_fields' | 'iron_compare_fields_map' | 'copper_compare_fields' | 'copper_compare_fields_map' | 'boron_compare_fields' | 'boron_compare_fields_map' | 'cec_compare_fields' | 'cec_compare_fields_map' | 'nutrient_prescription' | 'ph_water_compare_fields' | 'ph_water_compare_fields_map' | 'ph_buffer_compare_fields' | 'ph_buffer_compare_fields_map' | 'organic_matter_compare_fields' | 'organic_matter_compare_fields_map' | 'calcium_saturation_compare_fields' | 'calcium_saturation_compare_fields_map' | 'magnesium_saturation_compare_fields' | 'magnesium_saturation_compare_fields_map' | 'potassium_saturation_compare_fields' | 'potassium_saturation_compare_fields_map' | 'base_saturation_compare_fields' | 'base_saturation_compare_fields_map' | 'sodium_saturation_compare_fields' | 'sodium_saturation_compare_fields_map' | 'hydrogen_saturation_compare_fields' | 'hydrogen_saturation_compare_fields_map' | 'soil_zones' | 'soil_test_results_fields' | 'soil_results_respiration' | 'soil_results_weoc' | 'soil_results_weon' | 'soil_results_h3a_organic_p' | 'soil_results_macroaggregates' | 'soil_results_total_carbon' | 'soil_results_total_nitrogen' | 'soil_results_water_capacity' | 'dashboard_content';
    published: boolean;
    updatedAt: string;
};

export type moduleType = 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';

export const moduleType = {
    FIELD_PROPERTIES: 'field_properties',
    GENERAL: 'general',
    NUTRIENT_MANAGEMENT: 'nutrient_management',
    COVER_CROPS: 'cover_crops',
    TILLAGE: 'tillage',
    SOIL_HEALTH: 'soil_health',
    NOTES: 'notes',
    DASHBOARD: 'dashboard'
} as const;

export type sectionType = 'background' | 'nutrient_maps' | 'total_fertilizer' | 'fertilizer_map' | 'prescription_files' | 'recommended_mixes' | 'farm_wide_planting' | 'cover_crop_farm_mixes' | 'cover_crop_mix' | 'cover_crop_species' | 'cover_crop_mixes' | 'termination_plan' | 'cover_crop_roi' | 'cover_crop_composition' | 'biomass_cc_variability' | 'carbon_cc_variability' | 'nitrogen_cc_variability' | 'cn_ratio_cc_variability' | 'phosphorus_cc_variability' | 'potassium_cc_variability' | 'calcium_cc_variability' | 'magnesium_cc_variability' | 'sulfur_cc_variability' | 'zinc_cc_variability' | 'iron_cc_variability' | 'manganese_cc_variability' | 'copper_cc_variability' | 'boron_cc_variability' | 'advisor_farm_notes' | 'advisor_field_notes' | 'planting_dates' | 'planting_method' | 'termination_method' | 'benefits_analysis' | 'soil_compaction' | 'compaction_summary_farm' | 'compaction_summary_field' | 'compaction_map_farm' | 'depth_to_compaction_map' | 'average_resistance_chart' | 'soil_resistance_2_inch' | 'soil_resistance_4_inch' | 'soil_resistance_6_inch' | 'soil_resistance_8_inch' | 'soil_resistance_10_inch' | 'soil_resistance_12_inch' | 'soil_resistance_14_inch' | 'subsoil_map' | 'tillage_plan' | 'tillage_map' | 'recommendations' | 'overview' | 'lime_prescription' | 'lime_prescription_map' | 'phosphorus_prescription' | 'phosphorus_prescription_map' | 'potassium_prescription' | 'potassium_prescription_map' | 'sulfur_prescription' | 'sulfur_prescription_map' | 'problem_fields' | 'nutrient_test_results' | 'calcium_compare_fields' | 'calcium_compare_fields_map' | 'phosphate_compare_fields' | 'phosphate_compare_fields_map' | 'sulfur_compare_fields' | 'sulfur_compare_fields_map' | 'potassium_compare_fields' | 'potassium_compare_fields_map' | 'magnesium_compare_fields' | 'magnesium_compare_fields_map' | 'sodium_compare_fields' | 'sodium_compare_fields_map' | 'zinc_compare_fields' | 'zinc_compare_fields_map' | 'manganese_compare_fields' | 'manganese_compare_fields_map' | 'iron_compare_fields' | 'iron_compare_fields_map' | 'copper_compare_fields' | 'copper_compare_fields_map' | 'boron_compare_fields' | 'boron_compare_fields_map' | 'cec_compare_fields' | 'cec_compare_fields_map' | 'nutrient_prescription' | 'ph_water_compare_fields' | 'ph_water_compare_fields_map' | 'ph_buffer_compare_fields' | 'ph_buffer_compare_fields_map' | 'organic_matter_compare_fields' | 'organic_matter_compare_fields_map' | 'calcium_saturation_compare_fields' | 'calcium_saturation_compare_fields_map' | 'magnesium_saturation_compare_fields' | 'magnesium_saturation_compare_fields_map' | 'potassium_saturation_compare_fields' | 'potassium_saturation_compare_fields_map' | 'base_saturation_compare_fields' | 'base_saturation_compare_fields_map' | 'sodium_saturation_compare_fields' | 'sodium_saturation_compare_fields_map' | 'hydrogen_saturation_compare_fields' | 'hydrogen_saturation_compare_fields_map' | 'soil_zones' | 'soil_test_results_fields' | 'soil_results_respiration' | 'soil_results_weoc' | 'soil_results_weon' | 'soil_results_h3a_organic_p' | 'soil_results_macroaggregates' | 'soil_results_total_carbon' | 'soil_results_total_nitrogen' | 'soil_results_water_capacity' | 'dashboard_content';

export const sectionType = {
    BACKGROUND: 'background',
    NUTRIENT_MAPS: 'nutrient_maps',
    TOTAL_FERTILIZER: 'total_fertilizer',
    FERTILIZER_MAP: 'fertilizer_map',
    PRESCRIPTION_FILES: 'prescription_files',
    RECOMMENDED_MIXES: 'recommended_mixes',
    FARM_WIDE_PLANTING: 'farm_wide_planting',
    COVER_CROP_FARM_MIXES: 'cover_crop_farm_mixes',
    COVER_CROP_MIX: 'cover_crop_mix',
    COVER_CROP_SPECIES: 'cover_crop_species',
    COVER_CROP_MIXES: 'cover_crop_mixes',
    TERMINATION_PLAN: 'termination_plan',
    COVER_CROP_ROI: 'cover_crop_roi',
    COVER_CROP_COMPOSITION: 'cover_crop_composition',
    BIOMASS_CC_VARIABILITY: 'biomass_cc_variability',
    CARBON_CC_VARIABILITY: 'carbon_cc_variability',
    NITROGEN_CC_VARIABILITY: 'nitrogen_cc_variability',
    CN_RATIO_CC_VARIABILITY: 'cn_ratio_cc_variability',
    PHOSPHORUS_CC_VARIABILITY: 'phosphorus_cc_variability',
    POTASSIUM_CC_VARIABILITY: 'potassium_cc_variability',
    CALCIUM_CC_VARIABILITY: 'calcium_cc_variability',
    MAGNESIUM_CC_VARIABILITY: 'magnesium_cc_variability',
    SULFUR_CC_VARIABILITY: 'sulfur_cc_variability',
    ZINC_CC_VARIABILITY: 'zinc_cc_variability',
    IRON_CC_VARIABILITY: 'iron_cc_variability',
    MANGANESE_CC_VARIABILITY: 'manganese_cc_variability',
    COPPER_CC_VARIABILITY: 'copper_cc_variability',
    BORON_CC_VARIABILITY: 'boron_cc_variability',
    ADVISOR_FARM_NOTES: 'advisor_farm_notes',
    ADVISOR_FIELD_NOTES: 'advisor_field_notes',
    PLANTING_DATES: 'planting_dates',
    PLANTING_METHOD: 'planting_method',
    TERMINATION_METHOD: 'termination_method',
    BENEFITS_ANALYSIS: 'benefits_analysis',
    SOIL_COMPACTION: 'soil_compaction',
    COMPACTION_SUMMARY_FARM: 'compaction_summary_farm',
    COMPACTION_SUMMARY_FIELD: 'compaction_summary_field',
    COMPACTION_MAP_FARM: 'compaction_map_farm',
    DEPTH_TO_COMPACTION_MAP: 'depth_to_compaction_map',
    AVERAGE_RESISTANCE_CHART: 'average_resistance_chart',
    SOIL_RESISTANCE_2_INCH: 'soil_resistance_2_inch',
    SOIL_RESISTANCE_4_INCH: 'soil_resistance_4_inch',
    SOIL_RESISTANCE_6_INCH: 'soil_resistance_6_inch',
    SOIL_RESISTANCE_8_INCH: 'soil_resistance_8_inch',
    SOIL_RESISTANCE_10_INCH: 'soil_resistance_10_inch',
    SOIL_RESISTANCE_12_INCH: 'soil_resistance_12_inch',
    SOIL_RESISTANCE_14_INCH: 'soil_resistance_14_inch',
    SUBSOIL_MAP: 'subsoil_map',
    TILLAGE_PLAN: 'tillage_plan',
    TILLAGE_MAP: 'tillage_map',
    RECOMMENDATIONS: 'recommendations',
    OVERVIEW: 'overview',
    LIME_PRESCRIPTION: 'lime_prescription',
    LIME_PRESCRIPTION_MAP: 'lime_prescription_map',
    PHOSPHORUS_PRESCRIPTION: 'phosphorus_prescription',
    PHOSPHORUS_PRESCRIPTION_MAP: 'phosphorus_prescription_map',
    POTASSIUM_PRESCRIPTION: 'potassium_prescription',
    POTASSIUM_PRESCRIPTION_MAP: 'potassium_prescription_map',
    SULFUR_PRESCRIPTION: 'sulfur_prescription',
    SULFUR_PRESCRIPTION_MAP: 'sulfur_prescription_map',
    PROBLEM_FIELDS: 'problem_fields',
    NUTRIENT_TEST_RESULTS: 'nutrient_test_results',
    CALCIUM_COMPARE_FIELDS: 'calcium_compare_fields',
    CALCIUM_COMPARE_FIELDS_MAP: 'calcium_compare_fields_map',
    PHOSPHATE_COMPARE_FIELDS: 'phosphate_compare_fields',
    PHOSPHATE_COMPARE_FIELDS_MAP: 'phosphate_compare_fields_map',
    SULFUR_COMPARE_FIELDS: 'sulfur_compare_fields',
    SULFUR_COMPARE_FIELDS_MAP: 'sulfur_compare_fields_map',
    POTASSIUM_COMPARE_FIELDS: 'potassium_compare_fields',
    POTASSIUM_COMPARE_FIELDS_MAP: 'potassium_compare_fields_map',
    MAGNESIUM_COMPARE_FIELDS: 'magnesium_compare_fields',
    MAGNESIUM_COMPARE_FIELDS_MAP: 'magnesium_compare_fields_map',
    SODIUM_COMPARE_FIELDS: 'sodium_compare_fields',
    SODIUM_COMPARE_FIELDS_MAP: 'sodium_compare_fields_map',
    ZINC_COMPARE_FIELDS: 'zinc_compare_fields',
    ZINC_COMPARE_FIELDS_MAP: 'zinc_compare_fields_map',
    MANGANESE_COMPARE_FIELDS: 'manganese_compare_fields',
    MANGANESE_COMPARE_FIELDS_MAP: 'manganese_compare_fields_map',
    IRON_COMPARE_FIELDS: 'iron_compare_fields',
    IRON_COMPARE_FIELDS_MAP: 'iron_compare_fields_map',
    COPPER_COMPARE_FIELDS: 'copper_compare_fields',
    COPPER_COMPARE_FIELDS_MAP: 'copper_compare_fields_map',
    BORON_COMPARE_FIELDS: 'boron_compare_fields',
    BORON_COMPARE_FIELDS_MAP: 'boron_compare_fields_map',
    CEC_COMPARE_FIELDS: 'cec_compare_fields',
    CEC_COMPARE_FIELDS_MAP: 'cec_compare_fields_map',
    NUTRIENT_PRESCRIPTION: 'nutrient_prescription',
    PH_WATER_COMPARE_FIELDS: 'ph_water_compare_fields',
    PH_WATER_COMPARE_FIELDS_MAP: 'ph_water_compare_fields_map',
    PH_BUFFER_COMPARE_FIELDS: 'ph_buffer_compare_fields',
    PH_BUFFER_COMPARE_FIELDS_MAP: 'ph_buffer_compare_fields_map',
    ORGANIC_MATTER_COMPARE_FIELDS: 'organic_matter_compare_fields',
    ORGANIC_MATTER_COMPARE_FIELDS_MAP: 'organic_matter_compare_fields_map',
    CALCIUM_SATURATION_COMPARE_FIELDS: 'calcium_saturation_compare_fields',
    CALCIUM_SATURATION_COMPARE_FIELDS_MAP: 'calcium_saturation_compare_fields_map',
    MAGNESIUM_SATURATION_COMPARE_FIELDS: 'magnesium_saturation_compare_fields',
    MAGNESIUM_SATURATION_COMPARE_FIELDS_MAP: 'magnesium_saturation_compare_fields_map',
    POTASSIUM_SATURATION_COMPARE_FIELDS: 'potassium_saturation_compare_fields',
    POTASSIUM_SATURATION_COMPARE_FIELDS_MAP: 'potassium_saturation_compare_fields_map',
    BASE_SATURATION_COMPARE_FIELDS: 'base_saturation_compare_fields',
    BASE_SATURATION_COMPARE_FIELDS_MAP: 'base_saturation_compare_fields_map',
    SODIUM_SATURATION_COMPARE_FIELDS: 'sodium_saturation_compare_fields',
    SODIUM_SATURATION_COMPARE_FIELDS_MAP: 'sodium_saturation_compare_fields_map',
    HYDROGEN_SATURATION_COMPARE_FIELDS: 'hydrogen_saturation_compare_fields',
    HYDROGEN_SATURATION_COMPARE_FIELDS_MAP: 'hydrogen_saturation_compare_fields_map',
    SOIL_ZONES: 'soil_zones',
    SOIL_TEST_RESULTS_FIELDS: 'soil_test_results_fields',
    SOIL_RESULTS_RESPIRATION: 'soil_results_respiration',
    SOIL_RESULTS_WEOC: 'soil_results_weoc',
    SOIL_RESULTS_WEON: 'soil_results_weon',
    SOIL_RESULTS_H3A_ORGANIC_P: 'soil_results_h3a_organic_p',
    SOIL_RESULTS_MACROAGGREGATES: 'soil_results_macroaggregates',
    SOIL_RESULTS_TOTAL_CARBON: 'soil_results_total_carbon',
    SOIL_RESULTS_TOTAL_NITROGEN: 'soil_results_total_nitrogen',
    SOIL_RESULTS_WATER_CAPACITY: 'soil_results_water_capacity',
    DASHBOARD_CONTENT: 'dashboard_content'
} as const;

/**
 * MultiLineString Model
 */
export type MultiLineString = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'MultiLineString';
    coordinates: Array<Array<(Position2D | Position3D)>>;
};

export type type5 = 'MultiLineString';

export const type5 = {
    MULTI_LINE_STRING: 'MultiLineString'
} as const;

/**
 * MultiPoint Model
 */
export type MultiPoint = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'MultiPoint';
    coordinates: Array<(Position2D | Position3D)>;
};

export type type6 = 'MultiPoint';

export const type6 = {
    MULTI_POINT: 'MultiPoint'
} as const;

/**
 * MultiPolygon Model
 */
export type MultiPolygon = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'MultiPolygon';
    coordinates: Array<Array<Array<(Position2D | Position3D)>>>;
};

export type type7 = 'MultiPolygon';

export const type7 = {
    MULTI_POLYGON: 'MultiPolygon'
} as const;

/**
 * User information derived from the access token and (if available) the user
 * account.
 */
export type MyUser = {
    fullName: string;
    displayName: string;
    id?: (string | null);
    email: string;
    emailVerified?: boolean;
    farm?: (FarmSummary | null);
    emails?: (Array<(string)> | null);
    roles?: (Array<('admin' | 'staff' | 'grower')> | null);
    permissions: ResourcePermissions;
    farms?: (Array<FarmSummary> | null);
    [key: string]: unknown | string | boolean | ResourcePermissions;
};

/**
 * Returns a farm that is being onboarded.
 */
export type OnboardingFarm = {
    label: string;
    acreage?: (number | null);
    yearsOperated?: (number | null);
    yieldIssues?: (string | null);
    zipcode?: (string | null);
    goals?: Array<('provide_n' | 'suppress_weed' | 'reduce_erosion' | 'increase_organic_matter' | 'relieve_compaction' | 'mitigate_drainage' | 'water_infiltration' | 'longevity_resilience' | 'increase_yield' | 'profitability')>;
    id: string;
    roles?: Array<('owner' | 'operator' | 'customer_rep')>;
    permissions?: Array<('account:change_password' | 'account:create' | 'account:delete' | 'account:list' | 'account:read' | 'account:update' | 'account_internal:read' | 'account_internal:update' | 'farm:create' | 'farm:delete' | 'farm:invite' | 'farm:list' | 'farm:publicize' | 'farm:read' | 'farm:update' | 'farm:upload' | 'farm_internal:create' | 'farm_internal:list' | 'farm_internal:read' | 'farm_internal:update' | 'system_content:read' | 'system_content:update')>;
    registeredAcres?: number;
    enrolledAcres?: number;
    customerRep?: (AccountGet | null);
    users?: Array<FarmAccountGet>;
    isPublic?: boolean;
    /**
     * A Vayda growing year, starting with harvest (Oct 1) of the previous calendar year
     */
    annum?: number;
    [key: string]: unknown | string | number | FarmAccountGet | boolean;
};

/**
 * Point Model
 */
export type Point = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'Point';
    coordinates: (Position2D | Position3D);
};

export type type8 = 'Point';

export const type8 = {
    POINT: 'Point'
} as const;

/**
 * Polygon Model
 */
export type Polygon = {
    bbox?: ([
    number,
    number,
    number,
    number
] | [
    number,
    number,
    number,
    number,
    number,
    number
] | null);
    type: 'Polygon';
    coordinates: Array<Array<(Position2D | Position3D)>>;
};

export type type9 = 'Polygon';

export const type9 = {
    POLYGON: 'Polygon'
} as const;

export type Position2D = [
    number,
    number
];

export type Position3D = [
    number,
    number,
    number
];

/**
 * Stricter properties for raster layers.
 */
export type RasterLayerProps = {
    header?: (TilesetHeader | null);
    legend?: (TilesetLegend | null);
    statistics?: (TilesetStatistics | null);
};

/**
 * Data for one or more layers for a datasource, in raster format.
 */
export type RasterLayerResponse = {
    data: string;
    properties?: (RasterLayerProps | null);
    [key: string]: unknown | string;
};

/**
 * Provides a model for returning a user's permissions between the
 * app and any farms they have access to.
 */
export type ResourcePermissions = {
    app: Array<('account:change_password' | 'account:create' | 'account:delete' | 'account:list' | 'account:read' | 'account:update' | 'account_internal:read' | 'account_internal:update' | 'farm:create' | 'farm:delete' | 'farm:invite' | 'farm:list' | 'farm:publicize' | 'farm:read' | 'farm:update' | 'farm:upload' | 'farm_internal:create' | 'farm_internal:list' | 'farm_internal:read' | 'farm_internal:update' | 'system_content:read' | 'system_content:update')>;
    farms: {
        [key: string]: Array<('account:change_password' | 'account:create' | 'account:delete' | 'account:list' | 'account:read' | 'account:update' | 'account_internal:read' | 'account_internal:update' | 'farm:create' | 'farm:delete' | 'farm:invite' | 'farm:list' | 'farm:publicize' | 'farm:read' | 'farm:update' | 'farm:upload' | 'farm_internal:create' | 'farm_internal:list' | 'farm_internal:read' | 'farm_internal:update' | 'system_content:read' | 'system_content:update')>;
    };
};

export type SignedGetResponse = {
    url: string;
};

export type SignedPostResponse = {
    url: string;
    fields: {
        [key: string]: unknown;
    };
};

/**
 * Data for one or more layers for a datasource, in geojson format.
 */
export type SimpleFeaturesLayerResponse = {
    data: FeatureCollection;
    [key: string]: unknown | FeatureCollection;
};

/**
 * What is returned in API responses.
 */
export type SystemContentGet = {
    authorId: string;
    content?: TiptapContent;
    /**
     * A Vayda growing year, starting with harvest (Oct 1) of the previous calendar year
     */
    annum: number;
    contentType: 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';
    published: boolean;
    updatedAt: string;
    [key: string]: unknown | string | TiptapContent | number | boolean;
};

export type contentType = 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';

export const contentType = {
    COVER_CROPS_BACKGROUND: 'cover_crops_background',
    COVER_CROPS_BENEFITS: 'cover_crops_benefits',
    COVER_CROPS_ROI_BACKGROUND: 'cover_crops_roi_background',
    COVER_CROPS_NUTRIENT_COMPOSITION_BACKGROUND: 'cover_crops_nutrient_composition_background',
    NUTRIENT_MANAGEMENT_BACKGROUND: 'nutrient_management_background',
    TILLAGE_BACKGROUND: 'tillage_background',
    TILLAGE_APPROACH: 'tillage_approach',
    TILLAGE_UNDERSTANDING_COMPACTION: 'tillage_understanding_compaction',
    SOIL_HEALTH_BACKGROUND: 'soil_health_background',
    SOIL_HEALTH_ZONES_BACKGROUND: 'soil_health_zones_background',
    SOIL_HEALTH_TEST_RESULTS_BACKGROUND: 'soil_health_test_results_background',
    SOIL_HEALTH_RESPIRATION_BACKGROUND: 'soil_health_respiration_background',
    SOIL_HEALTH_WEOC_BACKGROUND: 'soil_health_weoc_background',
    SOIL_HEALTH_WEON_BACKGROUND: 'soil_health_weon_background',
    SOIL_HEALTH_H3A_ORGANIC_P_BACKGROUND: 'soil_health_h3a_organic_p_background',
    SOIL_HEALTH_MACROAGGREGATES_BACKGROUND: 'soil_health_macroaggregates_background',
    SOIL_HEALTH_TOTAL_CARBON_BACKGROUND: 'soil_health_total_carbon_background',
    SOIL_HEALTH_TOTAL_NITROGEN_BACKGROUND: 'soil_health_total_nitrogen_background',
    SOIL_HEALTH_WATER_CAPACITY_BACKGROUND: 'soil_health_water_capacity_background',
    DASHBOARD_SYSTEM_CONTENT: 'dashboard_system_content',
    SATELLITE_NDVI_EXPLAINER: 'satellite_ndvi_explainer',
    SATELLITE_BASELINE_NDVI_EXPLAINER: 'satellite_baseline_ndvi_explainer',
    SATELLITE_EVI_EXPLAINER: 'satellite_evi_explainer',
    SATELLITE_MSAVI_EXPLAINER: 'satellite_msavi_explainer',
    SATELLITE_NDRE_EXPLAINER: 'satellite_ndre_explainer',
    SATELLITE_CCCI_EXPLAINER: 'satellite_ccci_explainer',
    SATELLITE_NDVI_ANOMALY_EXPLAINER: 'satellite_ndvi_anomaly_explainer'
} as const;

/**
 * Statistics for a specific bucket within a legend range.
 */
export type TilesetBucketStatistics = {
    count?: number;
    percentage?: number;
    [key: string]: unknown | number;
};

/**
 * Accumulated statistics about an entire farm. Width and height make
 * no sense in this context, as the farm has several fields spread over an
 * area.
 */
export type TilesetFarmStatistics = {
    minimum: number;
    maximum: number;
    mean: number;
    nonMaskedCount?: number;
    buckets: {
        [key: string]: TilesetBucketStatistics;
    };
    [key: string]: unknown | number | TilesetBucketStatistics;
};

/**
 * Statistics about a specified field in the tileset.
 */
export type TilesetFieldStatistics = {
    minimum: number;
    maximum: number;
    mean: number;
    nonMaskedCount?: number;
    buckets: {
        [key: string]: TilesetBucketStatistics;
    };
    width?: number;
    height?: number;
    [key: string]: unknown | number | TilesetBucketStatistics;
};

/**
 * The pmtiles header information.
 *
 * Only critical items included in this schema model.
 *
 * TODO: More tightly constrain the header information (compression is an
 * enum) and use some library that doesn't depend on commandline pmtiles show
 * json format. The python library is still experimental and formats the json
 * subtly differently (e.g. min_zoom vs minzoom of json output) so this tries
 * to keep it inline with that.
 * See:
 * - https://pmtiles.io/typedoc/interfaces/Header.html
 * - https://github.com/protomaps/PMTiles/blob/main/python/pmtiles/tile.py#L202
 */
export type TilesetHeader = {
    tile_compression: string;
    tile_type: string;
    min_zoom: number;
    max_zoom: number;
};

/**
 * Represents legend information for the tileset.
 * Every field is colorized using the same information.
 */
export type TilesetLegend = {
    ranges: Array<TilesetLegendRange>;
    [key: string]: unknown | TilesetLegendRange;
};

/**
 * A legend bin applied to an actual raster file.
 */
export type TilesetLegendRange = {
    id: string;
    label: string;
    subLabel: (string | null);
    color: Array<Color>;
    maximum: number;
    minimum: number;
    [key: string]: unknown | string | Color | number;
};

/**
 * Represents legend information for the tileset.
 */
export type TilesetStatistics = {
    byField: {
        [key: string]: TilesetFieldStatistics;
    };
    farm: TilesetFarmStatistics;
    [key: string]: unknown | TilesetFieldStatistics | TilesetFarmStatistics;
};

/**
 * The rich text document provided by the tiptap editor.
 */
export type TiptapContent = {
    type?: 'doc';
    content?: Array<{
        [key: string]: unknown;
    }>;
};

export type type10 = 'doc';

export const type10 = {
    DOC: 'doc'
} as const;

/**
 * Class to represent the authentication service's view of the user. This
 * data is largely not stored in the database. Currently this is skewed
 * heavily to what Auth0 provides in its management API since that's the only
 * service in use.
 */
export type UserAuthInfo = {
    service?: 'auth0';
    adminLink?: string;
    connection: 'email_password' | 'google_oauth2' | 'unknown';
    userId: string;
    email: string;
    emailVerified?: boolean;
    lastLogin?: (string | null);
    createdAt?: string;
    updatedAt?: string;
    [key: string]: unknown | string | boolean;
};

export type service = 'auth0';

export const service = {
    AUTH0: 'auth0'
} as const;

export type connection = 'email_password' | 'google_oauth2' | 'unknown';

export const connection = {
    EMAIL_PASSWORD: 'email_password',
    GOOGLE_OAUTH2: 'google_oauth2',
    UNKNOWN: 'unknown'
} as const;

export type UserCreate = {
    fullName: string;
    displayName: string;
    email: string;
    [key: string]: unknown | string;
};

export type UserGet = {
    fullName: string;
    displayName: string;
    id: string;
    emails: Array<(string)>;
    roles: Array<('admin' | 'staff' | 'grower')>;
    farm?: (FarmSummary | null);
    farms?: Array<FarmSummary>;
    [key: string]: unknown | string | FarmSummary;
};

/**
 * Use this schema to allow users to self register their farm. No user
 * information is required, as it will be retrieved from the access token.
 */
export type UserRegister = {
    farm: FarmCreate;
    [key: string]: unknown | FarmCreate;
};

export type UserWithInternalGet = {
    fullName: string;
    displayName: string;
    id: string;
    emails: Array<(string)>;
    roles: Array<('admin' | 'staff' | 'grower')>;
    farm?: (FarmSummary | null);
    farms?: Array<FarmSummary>;
    authInfo: UserAuthInfo;
    authUsers: Array<UserAuthInfo>;
    [key: string]: unknown | string | FarmSummary | UserAuthInfo;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
};

export type CreateCmsAttachmentData = {
    body: Body_create_cms_attachment_farms__farm_id__annum__annum__attachments_cms_post;
    path: {
        annum: (number | null);
        farm_id: string;
    };
};

export type CreateCmsAttachmentResponse = (string);

export type CreateCmsAttachmentError = (HTTPValidationError);

export type GetCmsAttachmentData = {
    path: {
        farm_id: string;
        id: string;
    };
};

export type GetCmsAttachmentResponse = (unknown);

export type GetCmsAttachmentError = (HTTPValidationError);

export type CreateAttachmentData = {
    path: {
        annum: (number | null);
        datasource: 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';
        farm_id: string;
        filename: string;
    };
};

export type CreateAttachmentResponse = (SignedPostResponse);

export type CreateAttachmentError = (HTTPValidationError);

export type ListAttachmentsByDatasourceData = {
    path: {
        datasource: 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';
        farm_id: string;
    };
};

export type ListAttachmentsByDatasourceResponse = (Array<AttachmentResponse>);

export type ListAttachmentsByDatasourceError = (HTTPValidationError);

export type GetAttachmentUrlData = {
    path: {
        farm_id: string;
        key: string;
    };
};

export type GetAttachmentUrlResponse = (SignedGetResponse);

export type GetAttachmentUrlError = (HTTPValidationError);

export type GetAttachmentByKeyData = {
    path: {
        farm_id: string;
        key: string;
    };
};

export type GetAttachmentByKeyResponse = (AttachmentResponse);

export type GetAttachmentByKeyError = (HTTPValidationError);

export type GetDatasourcesResponse = (Datasources);

export type GetDatasourcesError = unknown;

export type GetDatasourceData = {
    path: {
        datasource: 'elevation' | 'field_boundary' | 'haney_lab' | 'misc_lab' | 'others' | 'photo' | 'plfa_lab' | 'sampling_plan' | 'sampling_points' | 'soil_lab' | 'texture_lab' | 'tnd_lab' | 'veris_lab' | 'pks_lime_rx' | 'deep_tillage_plan';
    };
};

export type GetDatasourceResponse = (DatasourceModel);

export type GetDatasourceError = (HTTPValidationError);

export type FieldBoundaryByLocationData = {
    query: {
        lat: number;
        lng: number;
    };
};

export type FieldBoundaryByLocationResponse = (Feature);

export type FieldBoundaryByLocationError = (HTTPValidationError);

export type LowResBoundariesByBboxData = {
    query: {
        max_lat: number;
        max_lng: number;
        min_lat: number;
        min_lng: number;
    };
};

export type LowResBoundariesByBboxResponse = (FeatureCollection);

export type LowResBoundariesByBboxError = (HTTPValidationError);

export type HighResBoundariesByDetectedIdData = {
    path: {
        detected_id: string;
    };
};

export type HighResBoundariesByDetectedIdResponse = (Feature);

export type HighResBoundariesByDetectedIdError = (HTTPValidationError);

export type GetFarmsData = {
    query?: {
        limit?: (number | null);
        offset?: (number | null);
    };
};

export type GetFarmsResponse = (Array<FarmGet>);

export type GetFarmsError = (HTTPValidationError);

export type CreateFarmData = {
    body: FarmCreate;
};

export type CreateFarmResponse = (FarmGet);

export type CreateFarmError = (HTTPValidationError);

export type GetAllFarmsData = {
    query?: {
        limit?: (number | null);
        offset?: (number | null);
    };
};

export type GetAllFarmsResponse = (Array<FarmGet>);

export type GetAllFarmsError = (HTTPValidationError);

export type GetFarmByIdData = {
    path: {
        farm_id: string;
    };
};

export type GetFarmByIdResponse = (FarmGet);

export type GetFarmByIdError = (HTTPValidationError);

export type UpdateFarmData = {
    body: FarmEdit;
    path: {
        farm_id: string;
    };
};

export type UpdateFarmResponse = (FarmGet);

export type UpdateFarmError = (HTTPValidationError);

export type DeleteFarmData = {
    path: {
        farm_id: string;
    };
};

export type DeleteFarmResponse = (unknown);

export type DeleteFarmError = (HTTPValidationError);

export type InviteToFarmData = {
    body: FarmInvite;
    path: {
        farm_id: string;
    };
};

export type InviteToFarmResponse = (FarmInviteResponse);

export type InviteToFarmError = (HTTPValidationError);

export type ExportFieldBoundariesData = {
    path: {
        annum: (number | null);
        farm_id: string;
        format: 'geopackage' | 'shapefile' | 'geojson' | 'csv' | 'gpx';
    };
    query?: {
        crs?: string;
        schema?: 'legacy' | 'imagery_pipeline' | 'default';
    };
};

export type ExportFieldBoundariesResponse = (unknown);

export type ExportFieldBoundariesError = (HTTPValidationError);

export type GetAnnumsForFarmData = {
    path: {
        farm_id: string;
    };
};

export type GetAnnumsForFarmResponse = (FarmAnnums);

export type GetAnnumsForFarmError = (HTTPValidationError);

export type PublicizeFarmData = {
    path: {
        farm_id: string;
    };
};

export type PublicizeFarmResponse = (FarmGet);

export type PublicizeFarmError = (HTTPValidationError);

export type PrivatizeFarmData = {
    path: {
        farm_id: string;
    };
};

export type PrivatizeFarmResponse = (FarmGet);

export type PrivatizeFarmError = (HTTPValidationError);

export type GetFieldImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type GetFieldImageryResponse = (ImageryFieldStatus);

export type GetFieldImageryError = (HTTPValidationError);

export type ListFieldUnusableMaskImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type ListFieldUnusableMaskImageryResponse = (Array<ImageryDelivery>);

export type ListFieldUnusableMaskImageryError = (HTTPValidationError);

export type GetFieldUnusableMaskImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        item_id: string;
    };
};

export type GetFieldUnusableMaskImageryResponse = (ColorizedLayerResponse);

export type GetFieldUnusableMaskImageryError = (HTTPValidationError);

export type ListFieldProductImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type ListFieldProductImageryResponse = (Array<ImageryDelivery>);

export type ListFieldProductImageryError = (HTTPValidationError);

export type GetFieldProductImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        item_id: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldProductImageryResponse = (ColorizedLayerResponse);

export type GetFieldProductImageryError = (HTTPValidationError);

export type GetFieldDeltaFromNormImageryData = {
    path: {
        annum: (number | null);
        baseline: string;
        farm_id: string;
        field_id: (string);
        item_id: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldDeltaFromNormImageryResponse = (ColorizedLayerResponse);

export type GetFieldDeltaFromNormImageryError = (HTTPValidationError);

export type ListFieldAnomaliesImageryData = {
    path: {
        annum: (number | null);
        confidence: 85 | 90 | 95;
        farm_id: string;
        field_id: (string);
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type ListFieldAnomaliesImageryResponse = (Array<ImageryDelivery>);

export type ListFieldAnomaliesImageryError = (HTTPValidationError);

export type GetFieldAnomaliesImageryData = {
    path: {
        annum: (number | null);
        confidence: 85 | 90 | 95;
        farm_id: string;
        field_id: (string);
        item_id: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldAnomaliesImageryResponse = (ColorizedLayerResponse);

export type GetFieldAnomaliesImageryError = (HTTPValidationError);

export type ListFieldColorizedBundleImageryData = {
    path: {
        annum: (number | null);
        confidence: 85 | 90 | 95;
        farm_id: string;
        field_id: (string);
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type ListFieldColorizedBundleImageryResponse = (Array<ImageryDelivery>);

export type ListFieldColorizedBundleImageryError = (HTTPValidationError);

export type GetFieldColorizedBundleImageryData = {
    path: {
        annum: (number | null);
        confidence: 85 | 90 | 95;
        farm_id: string;
        field_id: (string);
        item_id: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldColorizedBundleImageryResponse = (ColorizedBundleResponse);

export type GetFieldColorizedBundleImageryError = (HTTPValidationError);

export type GetFieldNormMapImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        period: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldNormMapImageryResponse = (ColorizedLayerResponse);

export type GetFieldNormMapImageryError = (HTTPValidationError);

export type GetFieldVarianceMapImageryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        period: string;
        product: 'ndvi' | 'endvi' | 'evi' | 'msavi' | 'ccci' | 'ndre';
    };
};

export type GetFieldVarianceMapImageryResponse = (ColorizedLayerResponse);

export type GetFieldVarianceMapImageryError = (HTTPValidationError);

export type GetFieldsByFarmData = {
    path: {
        annum: number;
        farm_id: string;
    };
};

export type GetFieldsByFarmResponse = (Array<FieldWithCurrentBoundary>);

export type GetFieldsByFarmError = (HTTPValidationError);

export type CreateFieldData = {
    body: FieldCreate;
    path: {
        annum: (number | null);
        farm_id: string;
    };
};

export type CreateFieldResponse = (FieldWithCurrentBoundary);

export type CreateFieldError = (HTTPValidationError);

export type GetFieldData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type GetFieldResponse = (FieldWithCurrentBoundary);

export type GetFieldError = (HTTPValidationError);

export type UpdateFieldData = {
    body: FieldEdit;
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type UpdateFieldResponse = (FieldWithCurrentBoundary);

export type UpdateFieldError = (HTTPValidationError);

export type DeleteFieldData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type DeleteFieldResponse = (Field);

export type DeleteFieldError = (HTTPValidationError);

export type FindCurrentFieldBoundaryData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type FindCurrentFieldBoundaryResponse = (FieldBoundaryGet);

export type FindCurrentFieldBoundaryError = (HTTPValidationError);

export type FindFieldBoundaryData = {
    path: {
        annum: (number | null);
        boundary_id: string;
        farm_id: string;
        field_id: (string);
    };
};

export type FindFieldBoundaryResponse = (FieldBoundaryGet);

export type FindFieldBoundaryError = (HTTPValidationError);

export type GetAnnumsForFieldData = {
    path: {
        farm_id: string;
        field_id: (string);
    };
};

export type GetAnnumsForFieldResponse = (Array<(number)>);

export type GetAnnumsForFieldError = (HTTPValidationError);

export type GetCombinedLayersForSourceData = {
    path: {
        annum: number;
        farm_id: string;
        source: 'nutrient_testing' | 'fertilizer_recommendation';
    };
};

export type GetCombinedLayersForSourceResponse = (SimpleFeaturesLayerResponse);

export type GetCombinedLayersForSourceError = (HTTPValidationError);

export type GetSingleLayerForSourceData = {
    path: {
        annum: number;
        farm_id: string;
        layer: 'awc' | 'cec7' | 'clay_total' | 'drainage_class' | 'farmland_class' | 'flood_frequency_dcd' | 'soil_erodability_factor' | 'organic_matter' | 'sand_total' | 'silt_total' | 'taxonomic_class' | 'wind_erodability' | 'water_table_depth_annual_min' | 'water_table_depth_q2_min';
        source: 'ssurgo';
    };
};

export type GetSingleLayerForSourceResponse = (SimpleFeaturesLayerResponse);

export type GetSingleLayerForSourceError = (HTTPValidationError);

export type ListDatesForLayerData = {
    path: {
        annum: number;
        farm_id: string;
        layer: 'ndvi' | 'baseline_ndvi' | 'evi' | 'msavi' | 'ndre' | 'ccci' | 'ndvi_anomaly';
        source: 'satellite_imagery';
    };
};

export type ListDatesForLayerResponse = (DatesForLayer);

export type ListDatesForLayerError = (HTTPValidationError);

export type GetSingleLayerForSourceWithDateData = {
    path: {
        annum: number;
        date: string;
        farm_id: string;
        layer: 'ndvi' | 'baseline_ndvi' | 'evi' | 'msavi' | 'ndre' | 'ccci' | 'ndvi_anomaly';
        source: 'satellite_imagery';
    };
};

export type GetSingleLayerForSourceWithDateResponse = (RasterLayerResponse);

export type GetSingleLayerForSourceWithDateError = (HTTPValidationError);

export type ListAllLayersForSourceData = {
    path: {
        source: 'ssurgo' | 'nutrient_testing' | 'fertilizer_recommendation' | 'satellite_imagery';
    };
    query: {
        annum: number;
        farm_id: string;
    };
};

export type ListAllLayersForSourceResponse = (Array<('awc' | 'cec7' | 'clay_total' | 'drainage_class' | 'farmland_class' | 'flood_frequency_dcd' | 'soil_erodability_factor' | 'organic_matter' | 'sand_total' | 'silt_total' | 'taxonomic_class' | 'wind_erodability' | 'water_table_depth_annual_min' | 'water_table_depth_q2_min' | 'vendor_cec_meq_100_g' | 'vendor_ph_h20' | 'vendor_ph_buffer' | 'vender_om' | 'vendor_p_ppm' | 'vendor_k_ppm' | 'vendor_ca_ppm' | 'vendor_mg_ppm' | 'vendor_s_ppm' | 'vendor_na_ppm' | 'vendor_zn_ppm' | 'vendor_fe_ppm' | 'vendor_mn_ppm' | 'vendor_cu_ppm' | 'vendor_b_ppm' | 'vendor_ca_sat_pct' | 'vendor_mg_sat_pct' | 'vendor_k_sat_pct' | 'base_sat' | 'vendor_na_sat_pct' | 'vendor_h_sat_pct' | 'rx_lime' | 'rx_s' | 'rx_p2o5_general' | 'rx_k2o_general' | 'ndvi' | 'baseline_ndvi' | 'evi' | 'msavi' | 'ndre' | 'ccci' | 'ndvi_anomaly')>);

export type ListAllLayersForSourceError = (HTTPValidationError);

export type GetInternalAllFarmsData = {
    query?: {
        centroid?: boolean;
        limit?: (number | null);
        offset?: (number | null);
        'soil-lab'?: boolean;
    };
};

export type GetInternalAllFarmsResponse = (Array<FarmWithInternalGet>);

export type GetInternalAllFarmsError = (HTTPValidationError);

export type CreateInternalFarmData = {
    body: FarmWithInternalCreate;
};

export type CreateInternalFarmResponse = (FarmWithInternalGet);

export type CreateInternalFarmError = (HTTPValidationError);

export type GetInternalAnnumsForAllFarmsResponse = (AnnumsList);

export type GetInternalAnnumsForAllFarmsError = unknown;

export type GetInternalFarmByIdData = {
    path: {
        farm_id: string;
    };
    query?: {
        centroid?: boolean;
        'soil-lab'?: boolean;
    };
};

export type GetInternalFarmByIdResponse = (FarmWithInternalGet);

export type GetInternalFarmByIdError = (HTTPValidationError);

export type UpdateInternalFarmData = {
    body: FarmWithInternalEdit;
    path: {
        farm_id: string;
    };
};

export type UpdateInternalFarmResponse = (FarmWithInternalGet);

export type UpdateInternalFarmError = (HTTPValidationError);

export type UpdateInternalFarmRolesData = {
    body: FarmAccountRoleEdit;
    path: {
        farm_id: string;
    };
};

export type UpdateInternalFarmRolesResponse = (FarmWithInternalGet);

export type UpdateInternalFarmRolesError = (HTTPValidationError);

export type UpdateInternalFieldForFarmData = {
    body: FieldWithInternalEdit;
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
    };
};

export type UpdateInternalFieldForFarmResponse = (FieldWithCurrentBoundary);

export type UpdateInternalFieldForFarmError = (HTTPValidationError);

export type GetInternalUserByIdData = {
    path: {
        user_id: string;
    };
};

export type GetInternalUserByIdResponse = (UserWithInternalGet);

export type GetInternalUserByIdError = (HTTPValidationError);

export type EditUserInternalData = {
    body: AccountInternalUpdate;
    path: {
        user_id: string;
    };
};

export type EditUserInternalResponse = (UserWithInternalGet);

export type EditUserInternalError = (HTTPValidationError);

export type ListSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type ListSectionsResponse = (Array<ModuleSectionGet>);

export type ListSectionsError = (HTTPValidationError);

export type ListPublishedSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type ListPublishedSectionsResponse = (Array<ModuleSectionGet>);

export type ListPublishedSectionsError = (HTTPValidationError);

export type CreateOrUpdateSectionData = {
    body: ModuleSectionEdit;
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
        section_type: 'background' | 'nutrient_maps' | 'total_fertilizer' | 'fertilizer_map' | 'prescription_files' | 'recommended_mixes' | 'farm_wide_planting' | 'cover_crop_farm_mixes' | 'cover_crop_mix' | 'cover_crop_species' | 'cover_crop_mixes' | 'termination_plan' | 'cover_crop_roi' | 'cover_crop_composition' | 'biomass_cc_variability' | 'carbon_cc_variability' | 'nitrogen_cc_variability' | 'cn_ratio_cc_variability' | 'phosphorus_cc_variability' | 'potassium_cc_variability' | 'calcium_cc_variability' | 'magnesium_cc_variability' | 'sulfur_cc_variability' | 'zinc_cc_variability' | 'iron_cc_variability' | 'manganese_cc_variability' | 'copper_cc_variability' | 'boron_cc_variability' | 'advisor_farm_notes' | 'advisor_field_notes' | 'planting_dates' | 'planting_method' | 'termination_method' | 'benefits_analysis' | 'soil_compaction' | 'compaction_summary_farm' | 'compaction_summary_field' | 'compaction_map_farm' | 'depth_to_compaction_map' | 'average_resistance_chart' | 'soil_resistance_2_inch' | 'soil_resistance_4_inch' | 'soil_resistance_6_inch' | 'soil_resistance_8_inch' | 'soil_resistance_10_inch' | 'soil_resistance_12_inch' | 'soil_resistance_14_inch' | 'subsoil_map' | 'tillage_plan' | 'tillage_map' | 'recommendations' | 'overview' | 'lime_prescription' | 'lime_prescription_map' | 'phosphorus_prescription' | 'phosphorus_prescription_map' | 'potassium_prescription' | 'potassium_prescription_map' | 'sulfur_prescription' | 'sulfur_prescription_map' | 'problem_fields' | 'nutrient_test_results' | 'calcium_compare_fields' | 'calcium_compare_fields_map' | 'phosphate_compare_fields' | 'phosphate_compare_fields_map' | 'sulfur_compare_fields' | 'sulfur_compare_fields_map' | 'potassium_compare_fields' | 'potassium_compare_fields_map' | 'magnesium_compare_fields' | 'magnesium_compare_fields_map' | 'sodium_compare_fields' | 'sodium_compare_fields_map' | 'zinc_compare_fields' | 'zinc_compare_fields_map' | 'manganese_compare_fields' | 'manganese_compare_fields_map' | 'iron_compare_fields' | 'iron_compare_fields_map' | 'copper_compare_fields' | 'copper_compare_fields_map' | 'boron_compare_fields' | 'boron_compare_fields_map' | 'cec_compare_fields' | 'cec_compare_fields_map' | 'nutrient_prescription' | 'ph_water_compare_fields' | 'ph_water_compare_fields_map' | 'ph_buffer_compare_fields' | 'ph_buffer_compare_fields_map' | 'organic_matter_compare_fields' | 'organic_matter_compare_fields_map' | 'calcium_saturation_compare_fields' | 'calcium_saturation_compare_fields_map' | 'magnesium_saturation_compare_fields' | 'magnesium_saturation_compare_fields_map' | 'potassium_saturation_compare_fields' | 'potassium_saturation_compare_fields_map' | 'base_saturation_compare_fields' | 'base_saturation_compare_fields_map' | 'sodium_saturation_compare_fields' | 'sodium_saturation_compare_fields_map' | 'hydrogen_saturation_compare_fields' | 'hydrogen_saturation_compare_fields_map' | 'soil_zones' | 'soil_test_results_fields' | 'soil_results_respiration' | 'soil_results_weoc' | 'soil_results_weon' | 'soil_results_h3a_organic_p' | 'soil_results_macroaggregates' | 'soil_results_total_carbon' | 'soil_results_total_nitrogen' | 'soil_results_water_capacity' | 'dashboard_content';
    };
};

export type CreateOrUpdateSectionResponse = (ModuleSectionGet);

export type CreateOrUpdateSectionError = (HTTPValidationError);

export type PublishSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        field_id: (string);
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type PublishSectionsResponse = (Array<ModuleSectionGet>);

export type PublishSectionsError = (HTTPValidationError);

export type ListFarmSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type ListFarmSectionsResponse = (Array<ModuleSectionGet>);

export type ListFarmSectionsError = (HTTPValidationError);

export type ListFarmPublishedSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type ListFarmPublishedSectionsResponse = (Array<ModuleSectionGet>);

export type ListFarmPublishedSectionsError = (HTTPValidationError);

export type CreateOrUpdateFarmSectionData = {
    body: ModuleSectionEdit;
    path: {
        annum: (number | null);
        farm_id: string;
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
        section_type: 'background' | 'nutrient_maps' | 'total_fertilizer' | 'fertilizer_map' | 'prescription_files' | 'recommended_mixes' | 'farm_wide_planting' | 'cover_crop_farm_mixes' | 'cover_crop_mix' | 'cover_crop_species' | 'cover_crop_mixes' | 'termination_plan' | 'cover_crop_roi' | 'cover_crop_composition' | 'biomass_cc_variability' | 'carbon_cc_variability' | 'nitrogen_cc_variability' | 'cn_ratio_cc_variability' | 'phosphorus_cc_variability' | 'potassium_cc_variability' | 'calcium_cc_variability' | 'magnesium_cc_variability' | 'sulfur_cc_variability' | 'zinc_cc_variability' | 'iron_cc_variability' | 'manganese_cc_variability' | 'copper_cc_variability' | 'boron_cc_variability' | 'advisor_farm_notes' | 'advisor_field_notes' | 'planting_dates' | 'planting_method' | 'termination_method' | 'benefits_analysis' | 'soil_compaction' | 'compaction_summary_farm' | 'compaction_summary_field' | 'compaction_map_farm' | 'depth_to_compaction_map' | 'average_resistance_chart' | 'soil_resistance_2_inch' | 'soil_resistance_4_inch' | 'soil_resistance_6_inch' | 'soil_resistance_8_inch' | 'soil_resistance_10_inch' | 'soil_resistance_12_inch' | 'soil_resistance_14_inch' | 'subsoil_map' | 'tillage_plan' | 'tillage_map' | 'recommendations' | 'overview' | 'lime_prescription' | 'lime_prescription_map' | 'phosphorus_prescription' | 'phosphorus_prescription_map' | 'potassium_prescription' | 'potassium_prescription_map' | 'sulfur_prescription' | 'sulfur_prescription_map' | 'problem_fields' | 'nutrient_test_results' | 'calcium_compare_fields' | 'calcium_compare_fields_map' | 'phosphate_compare_fields' | 'phosphate_compare_fields_map' | 'sulfur_compare_fields' | 'sulfur_compare_fields_map' | 'potassium_compare_fields' | 'potassium_compare_fields_map' | 'magnesium_compare_fields' | 'magnesium_compare_fields_map' | 'sodium_compare_fields' | 'sodium_compare_fields_map' | 'zinc_compare_fields' | 'zinc_compare_fields_map' | 'manganese_compare_fields' | 'manganese_compare_fields_map' | 'iron_compare_fields' | 'iron_compare_fields_map' | 'copper_compare_fields' | 'copper_compare_fields_map' | 'boron_compare_fields' | 'boron_compare_fields_map' | 'cec_compare_fields' | 'cec_compare_fields_map' | 'nutrient_prescription' | 'ph_water_compare_fields' | 'ph_water_compare_fields_map' | 'ph_buffer_compare_fields' | 'ph_buffer_compare_fields_map' | 'organic_matter_compare_fields' | 'organic_matter_compare_fields_map' | 'calcium_saturation_compare_fields' | 'calcium_saturation_compare_fields_map' | 'magnesium_saturation_compare_fields' | 'magnesium_saturation_compare_fields_map' | 'potassium_saturation_compare_fields' | 'potassium_saturation_compare_fields_map' | 'base_saturation_compare_fields' | 'base_saturation_compare_fields_map' | 'sodium_saturation_compare_fields' | 'sodium_saturation_compare_fields_map' | 'hydrogen_saturation_compare_fields' | 'hydrogen_saturation_compare_fields_map' | 'soil_zones' | 'soil_test_results_fields' | 'soil_results_respiration' | 'soil_results_weoc' | 'soil_results_weon' | 'soil_results_h3a_organic_p' | 'soil_results_macroaggregates' | 'soil_results_total_carbon' | 'soil_results_total_nitrogen' | 'soil_results_water_capacity' | 'dashboard_content';
    };
};

export type CreateOrUpdateFarmSectionResponse = (ModuleSectionGet);

export type CreateOrUpdateFarmSectionError = (HTTPValidationError);

export type PublishFarmSectionsData = {
    path: {
        annum: (number | null);
        farm_id: string;
        module_type: 'field_properties' | 'general' | 'nutrient_management' | 'cover_crops' | 'tillage' | 'soil_health' | 'notes' | 'dashboard';
    };
};

export type PublishFarmSectionsResponse = (Array<ModuleSectionGet>);

export type PublishFarmSectionsError = (HTTPValidationError);

export type RegisterData = {
    body: UserRegister;
};

export type RegisterResponse = (OnboardingFarm);

export type RegisterError = (HTTPValidationError);

export type GetOnboardingFarmResponse = (OnboardingFarm);

export type GetOnboardingFarmError = unknown;

export type UpdateOnboardingFarmData = {
    body: FarmEdit;
};

export type UpdateOnboardingFarmResponse = (OnboardingFarm);

export type UpdateOnboardingFarmError = (HTTPValidationError);

export type GetOnboardingFieldsResponse = (Array<FieldWithCurrentBoundary>);

export type GetOnboardingFieldsError = unknown;

export type CreateOnboardingFieldData = {
    body: FieldCreate;
};

export type CreateOnboardingFieldResponse = (FieldWithCurrentBoundary);

export type CreateOnboardingFieldError = (HTTPValidationError);

export type GetOnboardingFieldByIdData = {
    path: {
        field_id: (string);
    };
};

export type GetOnboardingFieldByIdResponse = (FieldWithCurrentBoundary);

export type GetOnboardingFieldByIdError = (HTTPValidationError);

export type UpdateOnboardingFieldData = {
    body: FieldEdit;
    path: {
        field_id: (string);
    };
};

export type UpdateOnboardingFieldResponse = (FieldWithCurrentBoundary);

export type UpdateOnboardingFieldError = (HTTPValidationError);

export type DeleteOnboardingFieldData = {
    path: {
        field_id: (string);
    };
};

export type DeleteOnboardingFieldResponse = (Field);

export type DeleteOnboardingFieldError = (HTTPValidationError);

export type FindCurrentOnboardingFieldBoundaryData = {
    path: {
        field_id: (string);
    };
};

export type FindCurrentOnboardingFieldBoundaryResponse = (FieldBoundaryGet);

export type FindCurrentOnboardingFieldBoundaryError = (HTTPValidationError);

export type CreateOnboardingAttachmentData = {
    path: {
        filename: string;
    };
};

export type CreateOnboardingAttachmentResponse = (SignedPostResponse);

export type CreateOnboardingAttachmentError = (HTTPValidationError);

export type OnboardingFieldBoundaryByLocationData = {
    query: {
        lat: number;
        lng: number;
    };
};

export type OnboardingFieldBoundaryByLocationResponse = (Feature);

export type OnboardingFieldBoundaryByLocationError = (HTTPValidationError);

export type OnboardingLowResBoundariesByBboxData = {
    query: {
        max_lat: number;
        max_lng: number;
        min_lat: number;
        min_lng: number;
    };
};

export type OnboardingLowResBoundariesByBboxResponse = (FeatureCollection);

export type OnboardingLowResBoundariesByBboxError = (HTTPValidationError);

export type OnboardingHighResBoundariesByDetectedIdData = {
    path: {
        detected_id: string;
    };
};

export type OnboardingHighResBoundariesByDetectedIdResponse = (Feature);

export type OnboardingHighResBoundariesByDetectedIdError = (HTTPValidationError);

export type ResendEmailVerificationResponse = (unknown);

export type ResendEmailVerificationError = unknown;

export type GetPublishedSystemContentData = {
    path: {
        annum: number;
        content_id: 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';
    };
};

export type GetPublishedSystemContentResponse = ((SystemContentGet | null));

export type GetPublishedSystemContentError = (HTTPValidationError);

export type UpdateSystemContentData = {
    body: TiptapContent;
    path: {
        annum: number;
        content_id: 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';
    };
};

export type UpdateSystemContentResponse = (SystemContentGet);

export type UpdateSystemContentError = (HTTPValidationError);

export type GetDraftSystemContentData = {
    path: {
        annum: number;
        content_id: 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';
    };
};

export type GetDraftSystemContentResponse = (SystemContentGet);

export type GetDraftSystemContentError = (HTTPValidationError);

export type PublishSystemContentData = {
    body: TiptapContent;
    path: {
        annum: number;
        content_id: 'cover_crops_background' | 'cover_crops_benefits' | 'cover_crops_roi_background' | 'cover_crops_nutrient_composition_background' | 'nutrient_management_background' | 'tillage_background' | 'tillage_approach' | 'tillage_understanding_compaction' | 'soil_health_background' | 'soil_health_zones_background' | 'soil_health_test_results_background' | 'soil_health_respiration_background' | 'soil_health_weoc_background' | 'soil_health_weon_background' | 'soil_health_h3a_organic_p_background' | 'soil_health_macroaggregates_background' | 'soil_health_total_carbon_background' | 'soil_health_total_nitrogen_background' | 'soil_health_water_capacity_background' | 'dashboard_system_content' | 'satellite_ndvi_explainer' | 'satellite_baseline_ndvi_explainer' | 'satellite_evi_explainer' | 'satellite_msavi_explainer' | 'satellite_ndre_explainer' | 'satellite_ccci_explainer' | 'satellite_ndvi_anomaly_explainer';
    };
};

export type PublishSystemContentResponse = (SystemContentGet);

export type PublishSystemContentError = (HTTPValidationError);

export type GetTileData = {
    path: {
        annum: number;
        farm_id: string;
        period: string;
        source: 'imagery';
        tileset_format: 'png' | 'tif' | 'jpg';
        tileset_type: 'ndvi' | 'baseline_ndvi' | 'evi' | 'msavi' | 'ndre' | 'ccci' | 'ndvi_anomaly';
        timestamp: string;
        x: number;
        y: number;
        z: number;
    };
};

export type GetTileResponse = (unknown);

export type GetTileError = (HTTPValidationError);

export type RegisterWithoutFarmResponse = (MyUser);

export type RegisterWithoutFarmError = unknown;

export type GetAccessTokenResponse = (AccessToken);

export type GetAccessTokenError = unknown;

export type GetUserByIdData = {
    path: {
        user_id: string;
    };
};

export type GetUserByIdResponse = (UserGet);

export type GetUserByIdError = (HTTPValidationError);

export type EditUserData = {
    body: AccountUpdate;
    path: {
        user_id: string;
    };
};

export type EditUserResponse = (UserGet);

export type EditUserError = (HTTPValidationError);

export type DeleteUserData = {
    path: {
        user_id: string;
    };
};

export type DeleteUserResponse = (unknown);

export type DeleteUserError = (HTTPValidationError);

export type GetAllUsersData = {
    query?: {
        limit?: (number | null);
        offset?: (number | null);
    };
};

export type GetAllUsersResponse = (Array<UserGet>);

export type GetAllUsersError = (HTTPValidationError);

export type CreateUserData = {
    body: UserCreate;
};

export type CreateUserResponse = (UserGet);

export type CreateUserError = (HTTPValidationError);

export type ChangeUserPasswordData = {
    path: {
        user_id: string;
    };
};

export type ChangeUserPasswordResponse = (ChangePasswordTicket);

export type ChangeUserPasswordError = (HTTPValidationError);

export type GetMyUserResponse = (MyUser);

export type GetMyUserError = unknown;